import utils from './index'
import { getUnitLabel } from './unit'
import moment from 'moment'
import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

/**
 * General utils functions used in the whole dashboard's application
 */
export let utilsMixin = {
  data() {
    return {
      isSmallScreen: window.innerWidth < 768,
      isMediumScreen: window.innerWidth >= 768 && window.innerWidth <= 1060,
      isLargeScreen: window.innerWidth > 1060 && window.innerWidth < 1600,
      isVeryLargeScreen: window.innerWidth >= 1600,
      locales: ['fr', 'en', 'de'],
    }
  },
  computed: {
    dateFormat: function() {
      //return this.$locale == "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
      return 'DD/MM/YYYY'
    },
    apiBaseURL: function() {
      return process.env.NODE_ENV == 'production'
        ? 'https://api.histoverydata.com'
        : process.env.NODE_ENV == 'test'
        ? 'https://api-preprod.histoverydata.com'
        : 'http://localhost:3000'
    },
    getCurrentUser: function() {
      return this.$store.getters['auth/user']
    },
    isAvailableUserForStreamProfile() {
      const currentUser = this.$store.getters['auth/user']
      return (
        currentUser.role !== 'partner' ||
        currentUser.email === 'terence.marill@gmail.com' ||
        currentUser.email === 'test@test.fr' ||
        currentUser.email === 'l.mourosque@ville-bormes.fr'
      )
    },
    getUserCredentials: function() {
      return this.$store.getters['auth/credentials']
    },
    configFilterHierarchy: function() {
      return this.$store.getters['config/filtersConfig']
    },
    configChartHierarchy: function() {
      return this.$store.getters['config/chartsConfig']
    },
    getCurrentPeriod: function() {
      return this.$store.getters['prefs/period']
    },
    sitesWithMap: function() {
      let user = this.getCurrentUser
      let sites = user.sites.filter(site => {
        return site.has_map
      })
      return sites
    },
    sitesWithSurvey: function() {
      let user = this.getCurrentUser
      let sites = user.sites.filter(site => {
        return site.has_survey
      })
      return sites
    },
    isMobileDevice: function() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        return true
      } else {
        return false
      }
    },
    isSmartphoneDevice: function() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        return true
      } else {
        return false
      }
    },
    isMobileScreen: function() {
      return this.isSmartphoneDevice && this.isSmallScreen
    },
    isSmartphoneScreen: function() {
      return this.isSmartphoneDevice && this.isSmallScreen
    },
    userSiteIDs: function() {
      let userSiteIDs = Array.from(
        this.getCurrentUser.sites.map(site => {
          return site.site
        }),
      )
      return userSiteIDs
    },
    formElementClass: function() {
      return {
        'col-auto': !this.isSmallScreen && !this.isSmartphoneDevice,
        'col-sm-12': this.isSmartphoneDevice || this.isSmartphoneDevice,
        'center-title': true,
      }
    },
  },
  methods: {
    handleResize: function(event) {
      const width = event.target.window.innerWidth
      this.isSmallScreen = width < 768
      this.isMediumScreen = width >= 768 && width <= 1060
      this.isLargeScreen = width > 1060 && width < 1600
      this.isVeryLargeScreen = width >= 1600
    },
    formatDateTime: function(dateTime) {
      return moment(dateTime).format('DD/MM/YYYY HH:mm')
    },
    isSameConfig: function() {
      if (this.chart && this.chart.config) {
        if (
          this.chart.config.type == this.config.type &&
          this.chart.config.data_type == this.config.data_type &&
          this.chart.config.data_value == this.config.data_value
        ) {
          if (
            (this.config.type == 'pie' || this.config.type == 'bar') &&
            this.chart.config.distribution_type == this.config.distribution_type
          ) {
            return true
          } else if (
            (this.config.type == 'pie' || this.config.type == 'bar') &&
            this.chart.config.distribution_type != this.config.distribution_type
          ) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },

    /**
     *
     * @param rows Array of object: {vModel, value}
     */
    setFormControlsDefault(controls) {
      if (!this.formControl) {
        console.error(
          'FormControls require a formControl property initialized in top level data of parent component.',
        )
        return
      }

      controls.forEach(control => {
        if (control.value !== undefined) {
          this.$set(this.formControl, control.vModel, control.value)
        } else {
          console.error(
            'Error in setFormControlsDefault(), could not find default value nor url parameter.',
            control,
          )
        }
      })
    },

    /**
     * Return config file for filters of specific files
     * @param {*} site
     */
    getConfigFiltersFromSite(site) {
      if (this.configFilterHierarchy.custom[site]) {
        return this.configFilterHierarchy.custom[site]
      } else {
        return this.configFilterHierarchy.filter_values
      }
    },

    /**
     * Return formatted label for duration in seconds or minutes
     * @param {*} duration
     * @param {*} timeUnit
     * @param {*} format
     */
    getVisitDurationLabel(duration, timeUnit, format) {
      let formatted = moment
        .utc(moment.duration(duration, timeUnit).asMilliseconds())
        .format(format)
      return formatted
    },

    onChartMouseOver(chart) {
      this.onOverChart = chart.id
    },

    onChartMouseLeave() {
      this.onOverChart = -1
    },

    /**
     * Return gradient color for battery line chart
     * @param {*} gradient
     */
    gradientBatteryColor(gradient, dataType) {
      if (dataType == 'battery_lifetime') {
        if (gradient < -0.5) {
          return '#ef4b39'
        } else if (gradient < -0.3) {
          return '#eed42b'
        } else if (gradient < -0.1) {
          return '#50f186'
        } else if (gradient < 0) {
          return '#50f186'
        } else if (gradient >= 0 && gradient <= 1) {
          return '#50f186'
        } else if (gradient > 1) {
          return '#50f186'
        }
      } else if (dataType == 'battery_temperature') {
        if (gradient < -0.5) {
          return '#60FBDA'
        } else if (gradient < -0.3) {
          return '#90F494'
        } else if (gradient < -0.1) {
          return '#B9E862'
        } else if (gradient < 0.0) {
          return '#C7E251'
        } else if (gradient < 0.2) {
          return '#EDD82F'
        } else if (gradient >= 0.2 && gradient <= 0.3) {
          return '#F18D28'
        } else if (gradient > 0.3) {
          return '#D8493E'
        }
      } else {
        return 'blue'
      }
    },

    showToast(text) {
      this.$toasted.show(text, {
        theme: 'toasted-primary',
        position: 'bottom-center',
        duration: 4000,
      })
    },

    /**
     * Generate chart title according to the chart's configuration and the wanted localization
     * @param {*} locale
     * @param {*} config
     */
    generateChartTitle: function(locale, config) {
      let chartTitle = ''

      if (!config || !config.data_type || !config.data_value) {
        return ''
      }

      if (config.data_type === 'distribution') {
        config.sort_by = 'all'
        chartTitle +=
          this.$t('titles.distribution.' + config.data_value, locale) +
          ' ' +
          this.$t('by', locale) +
          ' ' +
          String(this.$t('filter.' + config.distribution_type, locale)).toLowerCase()
      } else if (
        config.data_value == 'hotspot' ||
        config.data_value == 'cartel' ||
        config.data_value == 'immersive' ||
        config.data_value == 'augmentedvisit' ||
        config.data_value == 'interactiveobject' ||
        config.data_value == 'interactivebuilding' ||
        config.data_value == 'interactivecharacter' ||
        config.data_value == 'sequence'
      ) {
        chartTitle = this.$t(
          'titles.' +
            (config.type === 'bar' || config.type === 'pie' ? 'indicator' : config.type) +
            '.' +
            config.data_type +
            '.' +
            config.data_value,
          locale,
          [String(this.$t('chart.data_value.' + config.data_value))],
        )
      } else {
        chartTitle = this.$t(
          'titles.' +
            (config.type === 'bar' || config.type === 'pie' ? 'indicator' : config.type) +
            '.' +
            config.data_type +
            '.' +
            config.data_value,
          locale,
        )
      }

      if (config.sort_by !== 'all' && config.sort_by && config.data_value !== 'battery_lifetime') {
        chartTitle +=
          ' ' +
          this.$t('by', locale) +
          ' ' +
          String(this.$t('filter.' + config.sort_by, locale)).toLowerCase()
      }

      return chartTitle
    },
    getLocalizedTitle(titles) {
      if (titles[this.$locale]) {
        return titles[this.$locale]
      } else {
        let localeKey = Object.keys(titles)[0]
        return titles[localeKey]
      }
    },
  },
}

/**
 *
 */
export let sitesMixin = {
  dependencies: ['adminService'],
  computed: {
    sites: function() {
      let siteIDFilters = this.$store.getters['config/filtersConfig'].filter_values.site_location
      if (this.$store.getters['config/filtersConfig'].role !== 'partner') {
        return siteIDFilters
      }

      const siteIDs = siteIDFilters.filter(siteID => {
        let found = this.$store.getters['config/filtersConfig'].sites.find(userSite => {
          return userSite.site_location === siteID
        })
        return found ? true : false
      })
      return siteIDs
    },
  },
  methods: {
    /**
     *  Get list of areas name inside a site
     * @param site
     * @returns {string | VueI18n.LocaleMessage}
     */
    getSiteAreas(site) {
      return this.$i18n.messages[this.$i18n.locale].map_areas[site]
    },

    getLocalizedSiteName(site) {
      return this.$i18n.messages[this.$i18n.locale]['site_location'][site]
    },

    // /**
    //  * Return user's authorized sites
    //  * @returns {Array.<{id: any, name: string}>}
    //  */
    //  getUserSites() {
    //   let user = this.$store.getters["auth/user"]
    //
    //   if (user.sites.length > 0) {
    //     return user.sites
    //   } else {
    //     return await this.adminService.getAllSites()
    //   }
    // }
  },
}

/**
 * Mixins use for chart's components
 */
export let chartMixin = {
  data() {
    return {
      requestCount: 0,
      currentRequestId: '',
      previousConfig: null,
      dataLoadedError: false,
    }
  },
  computed: {
    /**
     * Return date format according to selected locale
     */
    dateFormat: function() {
      //return this.$locale == "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
      return 'DD/MM/YYYY'
    },
    /**
     * Check if the data is still loading in the current chart
     */
    isDataLoading: function() {
      if (this.config) {
        this.config['loading'] = this.requestCount > 0
      }
      return this.requestCount > 0
    },
  },
  methods: {
    /**
     * Return if the new period range is into the previous selected period (for TimeChart essentially)
     * @param {*} savedStart
     * @param {*} savedEnd
     * @param {*} period
     */
    checkNewRange(savedStart, savedEnd, period) {
      let selectedPeriod = new Array(2)
      let dataRangeType = 'NEW'

      if (!savedStart || !savedEnd) {
        selectedPeriod[0] = moment(period[0], this.dateFormat).format(this.dateFormat)
        selectedPeriod[1] = moment(period[1], this.dateFormat).format(this.dateFormat)
        return {
          selectedPeriod: selectedPeriod,
          dataRangeType: dataRangeType,
        }
      }

      let oldRange = {
        start: moment(this.savedStart, this.dateFormat),
        end: moment(this.savedEnd, this.dateFormat),
      }

      let newRange = {
        start: moment(period[0], this.dateFormat),
        end: moment(period[1], this.dateFormat),
      }

      if (
        newRange.start.isSameOrAfter(oldRange.start) &&
        newRange.end.isSameOrBefore(oldRange.end)
      ) {
        selectedPeriod[0] = period[0]
        selectedPeriod[1] = period[1]
        dataRangeType = 'ALREADY_PRESENT'
        //FILTER !
      } else {
        /* else if (newRange.start.isBefore(oldRange.start) && newRange.end.isSameOrBefore(oldRange.end)) {
                                                     selectedPeriod[0] = period[0];
                                                     selectedPeriod[1] = moment(oldRange.start, this.dateFormat).add(1, 'day').format(this.dateFormat);
                                                     dataRangeType = 'NEW_BEFORE'; //FETCH DATA AND FILTER
                                                   } else if (newRange.start.isSameOrAfter(oldRange.start) && newRange.end.isAfter(oldRange.end)) {
                                                     selectedPeriod[0] = moment(oldRange.end, this.dateFormat).add(1, 'day').format(this.dateFormat);
                                                     selectedPeriod[1] = period[1];
                                                     dataRangeType = 'NEW_AFTER'; //FETCH DATA AND FILTER
                                                   }*/
        selectedPeriod[0] = period[0]
        selectedPeriod[1] = period[1]
        dataRangeType = 'NEW' //FETCH DATA
      }

      return {
        selectedPeriod: selectedPeriod,
        dataRangeType: dataRangeType,
      }
    },
    filterResult: function(result, period) {
      let items = result.items

      //if (items && period) {
      switch (this.dataRangeType) {
        case 'ALREADY_PRESENT':
          items = items.filter(item => {
            return (
              moment(item.date, 'YYYY-MM-DD').isSameOrAfter(moment(period[0], this.dateFormat)) &&
              moment(item.date, 'YYYY-MM-DD').isSameOrBefore(moment(period[1], this.dateFormat))
            )
          })
          break
        /*
                                                                      case 'NEW_BEFORE':
                                                                        items = items.concat(this.dataset.items);
                                                                        items = items.filter(item => {
                                                                          return moment(item.date, 'YYYY-MM-DD').isSameOrBefore(moment(period[1], this.dateFormat));
                                                                        });
                                                                        break;
                                                                      case 'NEW_AFTER':
                                                                        items = items.concat(this.dataset.items);
                                                                        items = items.filter(item => {
                                                                          return moment(item.date, 'YYYY-MM-DD').isSameOrAfter(moment(period[0], this.dateFormat));
                                                                        });
                                                                        break;
                                                                      */
        case 'NEW':
          break
        default:
          break
      }

      result.items = items

      result.start = moment(period[0], this.dateFormat).format('YYYY-MM-DD')
      result.end = moment(period[1], this.dateFormat).format('YYYY-MM-DD')

      if (result.items) {
        result.items.sort((a, b) => {
          return new Date(a.date) - new Date(b.date)
        })
      }

      //}

      //this.lastLoadedStart = moment(result.items[result.items.length - 1].date, 'YYYY-MM-DD');
      //this.lastLoadedEnd = moment(result.items[0].date, 'YYYY-MM-DD');

      return result
    },
    /**
     * Return request ID according to period, user and chart's config
     * @param {*} config
     * @param {*} period
     * @param {*} dateFormat
     * @param {*} user
     */
    getRequestId: function(config, period, dateFormat, user) {
      let path = utils.pathGenerator(config, period[0], period[1], dateFormat, user)
      if (config.distribution_type) {
        path += '&distributionType=' + config.distribution_type.toLowerCase()
      }

      path += `&chart_id=${config.id}`

      return path
    },
    /**
     * Return if we need to request new data in the EditChartModal preview
     */
    hasToRequestNewData: function() {
      if (
        this.previousConfig &&
        this.previousConfig.data_type == this.config.data_type &&
        this.previousConfig.data_value == this.config.data_value &&
        this.previousConfig.distribution_type == this.config.distribution_type &&
        this.previousConfig.sort_by == this.config.sort_by &&
        JSON.stringify(this.previousConfig.filters) == JSON.stringify(this.config.filters)
      ) {
        return false
      } else {
        return true
      }
    },
    reloadData: function() {
      if (this.dataLoadedError) {
        this.loadConfigAndFetchData()
        this.dataLoadedError = false
      }
    },
    /**
     * Return label's title according to the label and the chart's sort by type
     * @param {*} sort
     * @param {*} label
     */
    getLabelTitle: function(sort, label) {
      if (sort == 'site_id' || sort == 'language') {
        return this.$t(`${sort}.${label}`)
      } else if (sort == 'histopad_rating' || sort == 'visit_rating') {
        return `${label}  ${Number(label) > 1 ? this.$t('stars') : this.$t('star')}`
      } else if (sort == 'collected_treasure_count') {
        return `${label}  ${Number(label) > 1 ? this.$t('treasures') : this.$t('treasure')}`
      } else {
        return label
      }
    },
    updateCheckedLegends: function() {
      this.checked.forEach(checked => {
        const foundChecked = this.chart.checked.find(item => {
          return item === checked
        })

        const foundUnchecked = this.chart.unchecked.find(item => {
          return item === checked
        })

        if (!foundChecked && !foundUnchecked) {
          this.chart.checked.push(checked)
        }
      })
    },
    getUnitLabel: function(dataset) {
      return getUnitLabel(dataset)
    },
  },
}

export const timeMixin = {
  computed: {
    startPeriod() {
      return moment(this.$store.getters['prefs/period'][0], 'DD/MM/YYYY')
    },
    endPeriod() {
      return moment(this.$store.getters['prefs/period'][1], 'DD/MM/YYYY')
    },
  },
  methods: {
    /**
     *
     * @param {*} period
     */
    async saveCurrentPeriod(period) {
      await this.$store.dispatch('prefs/setCurrentPeriod', period)
    },
  },
}
